import MultiSelect from 'components/ui/Dropdown/MultiSelect';
import { useEmployeeSubTypeEnabled } from 'hooks/useEmployeeSubTypeEnabled';
import { employeeSubTypeFilterOptions } from 'constants/employeeSubType';

const EMPLOYEE_SUB_TYPE_QUERY_PARAM = 'employee_sub_type';

const EmployeeTypeFilter = ({ selected }: { selected?: string | null }) => {
  const isEmployeeSubTypeEnabled = useEmployeeSubTypeEnabled();
  const value = selected ? [selected] : [];

  const onChange = (keys: string[]) => {
    const url = new URL(window.location.href);
    const next = keys.length === 1 ? keys[0] : null;

    if (next) {
      url.searchParams.set(EMPLOYEE_SUB_TYPE_QUERY_PARAM, next);
    } else {
      url.searchParams.delete(EMPLOYEE_SUB_TYPE_QUERY_PARAM);
    }
    url.searchParams.delete('page');

    window.location.assign(url.toString());
  };

  if (!isEmployeeSubTypeEnabled) {
    return null;
  }

  return (
    <MultiSelect
      id="sr-employee-type-filter"
      options={employeeSubTypeFilterOptions}
      name={'Employee Type'}
      value={value}
      onChange={onChange}
      disableChipsDisplay={false}
      disableAllOption={false}
    />
  );
};

export default EmployeeTypeFilter;
